// ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation(); // Detect current route
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on location change
  }, [location]);

  return null; // No UI rendered
};

export default ScrollToTop;
